<template>
  <teleport to="body">
    <div class="modal" v-if="open" @click.self.prevent="$emit('close')">
      <div class="content">
        <font-awesome-icon icon="fa-xmark" class="exit" @click="$emit('close')" />
        <div class="column-container">
          <header>
            <h1>Float Adjustment</h1>
            <p>Estimated Float Amount: <CurrencyFormatter :value="currentFloatAmount" :currency="currency" /></p>
          </header>
          <div class="float-item">
            <label>Add cash</label>
            <input type="number" v-model="creditAmount" min="0" placeholder="0.00" />
            <button @click="handleAmounts('add')">Apply addition</button>
          </div>

          <div class="float-item">
            <label>Remove cash</label>
            <input type="number" v-model="debitAmount" min="0" placeholder="0.00" @input="showReasonInput = true" />
            <select v-if="showReasonInput" v-model="debitReason">
              <option value="" disabled>Select a reason...</option>
              <option value="Cash Up">Cash Up</option>
              <option value="Trial Shift Payment">Trial Shift Payment</option>
              <option value="Petty Cash">Petty Cash</option>
              <option value="Other">Other</option>
            </select>
            <button @click="handleAmounts('remove')">Apply removal</button>
          </div>
          <div v-if="error.message" :class="['error-message', error.type]">
            {{ error.message }}
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { CurrencyFormatter } from "@monolith/components";
import { mapGetters } from "vuex";
export default {
  name: "FloatAdjustment",
  components: { CurrencyFormatter },
  data() {
    return {
      creditAmount: "",
      debitAmount: "",
      debitReason: "",
      showReasonInput: false,
      error: {
        message: "",
        type: "",
      },
    };
  },
  props: ["open", "currentFloatAmount"],
  emits: ["amountsChanged", "close"],
  methods: {
    handleAmounts(type) {
      this.error.message = "";
      this.error.type = "";
      let amounts = {};
      if (type === "add" && this.creditAmount) {
        amounts.amount = parseFloat(this.creditAmount);
        amounts.type = "credit";
      } else if (type === "remove" && this.debitAmount && this.debitReason) {
        amounts.amount = parseFloat(this.debitAmount);
        amounts.type = "debit";
        amounts.reason = this.debitReason;
      } else {
        if (type === "add" && !this.creditAmount) {
          this.error.message = "Please enter a valid amount to add.";
          this.error.type = "no-amount";
        }
        if (type === "remove") {
          if (!this.debitAmount) {
            this.error.message = "Please enter a valid amount to remove.";
            this.error.type = "no-amount";
          } else if (!this.debitReason) {
            this.error.message = "Please provide a reason for removal.";
            this.error.type = "no-reason";
          }
        }
      }
      if (!this.error.message) {
        this.$emit("amountsChanged", amounts);
        this.$emit("close");
        this.creditAmount = "";
        this.debitAmount = "";
        this.debitReason = "";
        this.showReasonInput = false;
      }
    },
  },

  computed: {
    ...mapGetters(["currency"]),
  },

  watch: {},
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.modal {
  margin: 0;

  .column-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    .no-amount,
    .no-reason {
      color: var(--warning-colour);
    }

    header {
      text-align: center;
    }

    h1 {
      font-size: 1.8rem;
      margin-bottom: 1rem;
      color: var(--text-primary);
    }

    .float-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;

      button {
        padding: 0.5rem 1rem;
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
        border: none;
        box-shadow: var(--box-shadow);
        padding: 0.5rem 1rem;
        margin: 0.5rem 0;
        border-radius: 0.5rem;
        cursor: pointer;
      }

      label {
        font-size: 1rem;
        font-weight: 600;
        color: var(--action-colour);
      }

      input,
      select {
        padding: 0.75rem;
        text-align: center;
        font-size: 1.2rem;
        border: 2px solid var(--border-color);
        border-radius: 0.5rem;

        &:focus {
          outline: none;
          border-color: var(--primary-color);
          box-shadow: var(--box-shadow);
        }
      }

      select {
        padding: 0.4rem 0.5rem;
        font-size: 0.9rem;
      }
    }
  }
}

.content {
  width: 400px;
  max-width: 90vw;
}
</style>
